/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const USER_PREF_VIDEO_WINDOW_SET_GHOST_MODE = 'USER_PREF_VIDEO_WINDOW_SET_GHOST_MODE';
export const USER_PREF_VIDEO_WINDOW_SET_SELECTED_OPTION =
    'USER_PREF_VIDEO_WINDOW_SET_SELECTED_OPTION';
